import React, { useMemo } from 'react';
import ContactsIcon from '@mui/icons-material/Contacts';
import { useLanguage } from '../../../../context/LanguageContext';
import { Store } from '../../../../types/Store';
import StoreCard from './common/StoreCard';
import StoreTable from './common/StoreTable';

interface PrecosProps {
    store: Store;
    isEditable?: boolean;
}

const formatDateTime = (dateString?: string) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
};

const Precos = ({ store }: PrecosProps) => {
    const { t } = useLanguage();
    const precos = store.CONTACT_PRECO || [];

    const columns = useMemo(() => [
        { label: t('pages.store.email'), key: 'EMAIL_ADDRESS' },
        {
            label: t('pages.store.updateDate'),
            render: (preco: any) => formatDateTime(preco.UPDATE_DATE),
        },
    ], [t]);

    return (
        <StoreCard
            title={t('pages.store.precoContacts')}
            icon={<ContactsIcon sx={{ color: 'primary.main' }} />}
            isEmpty={precos.length === 0}
            emptyMessage={t('pages.store.noPrecos')}
        >
            {precos.length > 0 && <StoreTable columns={columns} data={precos} />}
        </StoreCard>
    );
};

export default Precos;
